<template>
  <form
    class="form"
    :disabled="isLoading"
    @submit.prevent="submitForm"
  >
    <Stack gap="4 ">
      <Title>{{ isEdit ? 'Edit Team' : 'Create a new Team' }}</Title>

      <input
        id="team_name"
        v-model="teamName"
        class="stk-input"
        type="text"
        placeholder="Team name"
        name="team_name"
        required
      />

      <textarea
        id="team_description"
        v-model="teamDescription"
        class="stk-input"
        placeholder="Team description"
        name="team_description"
      ></textarea>

      <Buttons justify="between">
        <Button variant="primary" :loading="isLoading">
          {{ isEdit ? "Save Changes" : "Create Team" }}
        </Button>
        <Button @click.prevent="emit('onClose', false)"> Cancel </Button>
      </Buttons>
    </Stack>
  </form>
</template>

<script setup>
import { computed, defineEmits, ref, watch } from "vue";
import { ToastProgrammatic as Toast } from 'buefy';
import { Button, Buttons, Stack, Title } from "@stakeui";
import { useTeamsStore } from "@frontend/ui/stores/teamsStore.js";

const teamsStore = useTeamsStore();

const props = defineProps({
  team: {
    type: Object,
    default: null,
  },
});

const teamName = ref(props.team?.name ?? '');
const teamDescription = ref(props.team?.description ?? '');

const emit = defineEmits(["onClose"]);

// We're in edit mode if we're passing a team
const isEdit = computed(() => !!props.team?.external_id);
const isLoading = computed(() => teamsStore.isSavingTeam);

const submitForm = async () => {
  try {
    await teamsStore.saveTeam(props.team?.external_id, teamName.value, teamDescription.value);

    if (!isEdit.value) {
      teamName.value = '';
      teamDescription.value = '';
    }

    Toast.open({
      message: `Team successfully saved.`,
      type: 'is-success',
    });
  } catch (err) {
    console.error('Team save failed', err);

    Toast.open({
      message: `There was an error saving the team.`,
      type: 'is-danger',
    });
  }
};

// If the parent swaps the team prop, keep fields in sync
watch(
  () => props.team,
  (t) => {
    teamName.value = t?.name ?? '';
    teamDescription.value = t?.description ?? '';
  },
  { immediate: true }
);
</script>

<style scoped>
.form {
  padding: 0.5em;
  width: 28rem;
}
</style>
